module.exports = __webpack_public_path__ + "img/cause2Blue.1756ad5d.png";